import { render, staticRenderFns } from "./importform.vue?vue&type=template&id=04455344&scoped=true&"
import script from "./importform.vue?vue&type=script&lang=js&"
export * from "./importform.vue?vue&type=script&lang=js&"
import style0 from "./importform.vue?vue&type=style&index=0&id=04455344&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04455344",
  null
  
)

export default component.exports